import { all } from 'redux-saga/effects';
import authSagas from './auth/saga';
// import todoSagas from './todo/saga';
import { watchFetchCompleteReport, watchFetchReportCopper, watchFetchReportGpon, watchFetchReportHfc, watchFetchStasticsReport, watchFetchTicketCountsData } from './dashboard/saga';
import { watchFetchTickets, watchFetchTicket, watchUpdateTicketStatus, watchUpdateTicket, watchCreateTicket, watchCloseTicket, watchFilterFetchTickets, watchCreateTicketComment, watchDeleteTicketComment, watchUpdateMaterialTicket, watchUpdateTicketTechnician,  } from './ticket/saga';
import { watchFetchUsers, watchFetchUser, watchChangePassword, watchUpdateUser, watchCreateUser, watchDeleteUser, watchFetchUserTickets } from './user/saga';

import chatSagas from './chat/saga';
import surveyListSagas from './surveyList/saga';
import surveyDetailSagas from './surveyDetail/saga';
import { watchFetchDailyReport, watchFetchDailyReports, watchFetchReportStatus, watchFetchReportTechnician } from './report/saga';
import { watchFetchRoles } from './setting/saga';
import { watchFetchCompany } from './company/saga';

export default function* rootSaga(getState) {
  yield all([
    authSagas(),
    // todoSagas(),
    watchFetchTicketCountsData(),
    watchFetchStasticsReport(),
    watchFetchCompleteReport(),
    watchFetchReportHfc(),
    watchFetchReportGpon(),
    watchFetchReportCopper(),

    watchFetchTickets(),
    watchFilterFetchTickets(),
    watchFetchTicket(),
    watchUpdateTicketStatus(),
    watchCreateTicket(),
    watchUpdateTicket(),
    watchUpdateMaterialTicket(),
    watchCloseTicket(),
    watchCreateTicketComment(),
    watchDeleteTicketComment(),
    
    watchFetchDailyReport(),
    watchFetchDailyReports(),
    watchFetchReportTechnician(),
    watchUpdateTicketTechnician(),
    watchFetchReportStatus(),

    watchFetchRoles(),
    
    watchFetchCompany(),

    watchCreateUser(),
    watchFetchUsers(),
    watchFetchUser(),
    watchFetchUserTickets(),
    watchUpdateUser(),
    watchDeleteUser(),
    watchChangePassword(),

    chatSagas(),
    surveyListSagas(),
    surveyDetailSagas(),
  ]);
}
